import config from './config';

/** Settings for account page.  */
const account = config({
  /** Defaults for all sites and locales. */
  default: {
    /** Default settings for all languages. */
    default: {
      /**
       * Namespace UUID for generating deterministic user UUIDs from customer IDs.
       * Used to create consistent UUIDs for session storage across logins.
       */
      userUuidNamespace: '6ba7b810-9dad-11d1-80b4-00c04fd430c8',

      /**
       * Account address links.
       */
      accountAddressLinks: true,

      /**
       * Account payment links.
       */
      accountPaymentLinks: false,

      /**
       * The maximum number of saved addresses allowed.
       *
       * This number will also determine the amount of localized strings we will
       * have in `convertNumberToWord - @/libs/react/src/utils/convert-numbers-to-word.ts`.
       * So whenever `maxSavedAddresses` is updated make sure to update the number
       * of localized strings in `convertNumberToWord`.
       */
      maxSavedAddresses: 10,

      /**
       * Account wallet settings.
       */
      wallet: {
        /** If the wallet feature is enabled. */
        enabled: false,

        /** Maximum number of payments that can be saved in a wallet. */
        maxNumberOfSavedPayments: 10
      }
    }
  },
  'TEVA-US': { default: { wallet: { enabled: false } } }
});

export default account;
